"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  position: 0,
  positionRatio: 0,
  start: 0,
  end: 0,
  viewHeight: 0,
  scrollHeight: 0,
  ready: false,
  onStart: true,
  onMiddle: false,
  onEnd: false,
  children: [],
  // autoFrame: props.autoFrame,
  // autoScroll: props.autoScroll,
  originalPosition: null,
  changedPosition: null,
  timeStamp: null,
  scrolling: false,
  wheeling: false,
  touching: false,
  moving: false,
  resting: true,
  touches: [],
  deltaY: 0
};
exports.default = _default;